
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/confidentialite",
      function () {
        return require("private-next-pages/fr/confidentialite.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/confidentialite"])
      });
    }
  